export default __webpack_public_path__ + "static/media/SndLowerKDownBumpLine.48ef1afb.mp3";